/* src/app/shared/library/ddtopnavlinks/ddtopnavlinks.component.scss */
ul {
  display: inline-flex;
  list-style-type: none;
  margin: 0;
  padding: 0;
  height: 100%;
  gap: 0;
  align-items: center;
}
ul li {
  display: inline-flex;
  align-items: center;
  height: 100%;
  height: 2.5rem;
}
ul li a {
  display: inline-flex;
  align-items: center;
  height: 100%;
  padding: 0 0.6rem;
  color: var(--surface-900);
  text-decoration: none;
  font-size: 1.2rem;
  transition: all 0.3s ease;
  overflow: hidden;
  width: max-content;
  font-size: 0.9rem;
  font-weight: 500;
  height: 3rem;
}
ul li a:hover {
  color: var(--primary-color);
  position: relative;
}
ul li .active {
  color: var(--primary-color) !important;
  position: relative;
  font-weight: 500 !important;
  background: var(--primary-50);
  border-bottom: solid 1px var(--primary-300);
  border-top: solid 1px var(--primary-300);
  height: 2.5rem;
  border-radius: 1rem;
}
/*# sourceMappingURL=ddtopnavlinks.component.css.map */
